import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  liveAttLoading: false,
  liveAttSuccess: false,
  liveAttError: false,
  liveAttMessage: null,

  liveAttGetLoading: false,
  liveAttGetSuccess: false,
  liveAttGetError: false,
  liveAttGetMessage: null,
  liveAttGetData: null,
};

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;
const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchLiveAttData = createAsyncThunk(
  "fetchLiveAttData",
  async (body) => {
    const { path, data } = body;
    return await axios
      .post(`${baseUrl}${path}`, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveLiveAtt = createAsyncThunk("saveLiveAtt", async (data) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };

  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(`${baseUrl}admin/createBranch`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            alert("You are offline. Please check your internet connection.");
          } else {
            alert("An error occurred. Please try again later.");
          }
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        });
});

const liveAttendanceSlice = createSlice({
  name: "liveAttendance",
  initialState,

  reducers: {
    initState: (state) => {
      state.liveAttLoading = false;
      state.liveAttSuccess = false;
      state.liveAttError = false;
      state.liveAttMessage = null;
    },
    initLiveAttState: (state) => {
      state.liveAttGetLoading = false;
      state.liveAttGetSuccess = false;
      state.liveAttGetError = false;
      state.liveAttGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchLiveAttData.pending, (state, action) => {
      state.liveAttGetLoading = true;
      state.liveAttGetSuccess = false;
      state.liveAttGetError = false;
      state.liveAttGetMessage = null;
      state.liveAttGetData = null;
    });
    builder.addCase(fetchLiveAttData.fulfilled, (state, action) => {
      console.log("action action action", action.payload)
      const status = action.payload.status;
      if (status === 200) {
        if (
          action.payload.data.status == false ||
          action.payload.data.status == "false"
        ) {
          state.liveAttGetLoading = false;
          state.liveAttGetSuccess = false;
          state.liveAttGetError = true;
          state.liveAttGetMessage = action.payload.data?.msg;
          state.liveAttGetData = [];
        } else {
          state.liveAttGetLoading = false;
          state.liveAttGetSuccess = true;
          state.liveAttGetError = false;
          state.liveAttGetMessage = action.payload.data?.message;
          state.liveAttGetData = action.payload.data ? action.payload.data : [];
        }
      } else {
        state.liveAttGetLoading = false;
        state.liveAttGetSuccess = false;
        state.liveAttGetError = true;
        state.liveAttGetMessage = action.payload.data?.msg
          ? action.payload.data?.msg
          : action.payload.data?.message;
        state.liveAttGetData = [];
      }
    });
    builder.addCase(fetchLiveAttData.rejected, (state, action) => {
      state.liveAttGetLoading = false;
      state.liveAttGetSuccess = false;
      state.liveAttGetError = true;
      state.liveAttGetMessage = action.payload.data.message;
      state.liveAttGetData = null;
    });
    // To create branch
    builder.addCase(saveLiveAtt.pending, (state, action) => {
      state.liveAttLoading = true;
      state.liveAttSuccess = false;
      state.liveAttError = false;
      state.liveAttMessage = null;
    });
    builder.addCase(saveLiveAtt.fulfilled, (state, action) => {
      state.liveAttLoading = false;
      state.liveAttSuccess = accountType == 2 ? false : true;
      state.liveAttError = accountType == 2 ? true : false;
      state.liveAttMessage = action.payload.data.message;
    });
    builder.addCase(saveLiveAtt.rejected, (state, action) => {
      state.liveAttLoading = false;
      state.liveAttSuccess = false;
      state.liveAttError = true;
      state.liveAttMessage = action.payload.data.message;
    });
  },
});

export const { initState, initLiveAttState } = liveAttendanceSlice.actions;

export default liveAttendanceSlice.reducer;
